import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface IButtonAddAttribute {
  withoutItemMessage: string;
  btnAddMessage: string;
  hiddenBtnAdd?: boolean;
  hiddenWithoutItemMessage?: boolean;
}

@Component({
  selector: 'json-template-button-add-attribute',
  templateUrl: './template-button-add-attribute.component.html',
  styleUrls: ['./template-button-add-attribute.component.scss']
})

export class TemplateButtonAddAttribute implements OnInit {
  @Input() config: IButtonAddAttribute;
  @Output() addAttributeEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() { }

  public add(type) {
    this.addAttributeEvent.emit(type);
  }
}
